"use client";

import { useTranslations } from "next-intl";

import { socialLinks } from "@/content/trust";

import { SocialLinkIcon } from "./SocialLinkIcon";

export const SocialLinks = () => {
  const t = useTranslations();

  return (
    <div className="flex flex-col gap-2">
      <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-muted-foreground">
        {t("footer.followUs")}
      </p>
      <ul className="flex flex-wrap gap-2">
        {socialLinks.map((link) => (
          <li key={link.id}>
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.label}
              className="inline-flex size-9 items-center justify-center rounded-lg border border-border bg-transparent text-muted-foreground transition-colors hover:border-[color-mix(in_oklch,var(--foreground)_30%,transparent)] hover:text-foreground"
            >
              <SocialLinkIcon id={link.id} />
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
